export default __webpack_public_path__ + "static/website-meta-share-dark-12610d5758c86e27da7448478f221757.jpg";